// src/components/BookImage.jsx
import React, { useState, useEffect } from 'react';
import defaultBook from '../../assets/defaultBook.png'; // Asegúrate de tener esta imagen en la ruta especificada

const BookImage = ({ src, alt, className }) => {
  const [imgSrc, setImgSrc] = useState(defaultBook);

  /**
   * Verifica si el `src` proporcionado es inválido.
   * Un `src` es inválido si:
   * - Está vacío, es null o undefined.
   * - No es una URL válida.
   * - No es una cadena Base64 válida de una imagen.
   *
   * @param {string} source - La fuente de la imagen a validar.
   * @returns {boolean} - Retorna true si el `src` es inválido, de lo contrario false.
   */
  const isInvalidSrc = (source) => {
    if (!source) return true; // Verifica si el `src` está vacío o es null/undefined

    const trimmedSrc = source.trim();

    // Intentar crear un objeto URL para verificar si es una URL válida
    try {
      new URL(trimmedSrc);
      return false; // Es una URL válida
    } catch (err) {
      // No es una URL válida, proceder a verificar si es Base64
    }

    // Expresión regular para verificar si es una cadena Base64 válida de una imagen
    const base64Regex = /^data:image\/[a-zA-Z]+;base64,[A-Za-z0-9+/]+={0,2}$/;
    return !base64Regex.test(trimmedSrc);
  };

  // useEffect para actualizar imgSrc cuando cambia la prop src
  useEffect(() => {
    if (isInvalidSrc(src)) {
      setImgSrc(defaultBook);
    } else {
      setImgSrc(src);
    }
  }, [src]);

  /**
   * Maneja el error de carga de la imagen.
   * Si la imagen actual no es la imagen por defecto, la reemplaza por la imagen por defecto.
   */
  const handleError = () => {
    if (imgSrc !== defaultBook) {
      setImgSrc(defaultBook);
    }
  };

  return (
    <img
      src={imgSrc}
      alt={alt || 'Portada del libro'}
      onError={handleError}
      className={className}
    />
  );
};

export default BookImage;
